import React from 'react';
import { SEOHead } from '../seo';
import { seoConfigs } from '../../utils/seo-configs';
import {
  HeroSection,
  HowItWorksSection,
  TherapistJoinSection,
  TherapySpecialtiesSection
} from './index';

function HomePage() {

  return (
    <>
      <SEOHead {...seoConfigs.home} />
      
      <div className="min-h-screen bg-[#e4fde1]" style={{ marginTop: '-200px', paddingTop: '200px' }}>
        <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <HeroSection />
          <HowItWorksSection />
        </main>
        
        {/* Therapist Join Section - Full width */}
        <TherapistJoinSection />
        
        {/* Full width section - moved to bottom */}
        <TherapySpecialtiesSection />
      </div>
    </>
  );
}

export default HomePage; 